export default __webpack_public_path__ + "static/Tek_Fence_Foundation-ec376ddd60334eb59d2284bdd0f10d83.png";